'use strict';

const AUTH_KEYS = ['token', 'tenantid', 'tenantId', 'tenant_id', 'tenant', 'user'];

export function getAuthItem(key) {
  try {
    return sessionStorage.getItem(key);
  } catch (_) {
    return null;
  }
}

export function setAuthItem(key, value) {
  if (value === undefined || value === null) return;
  sessionStorage.setItem(key, String(value));
}

export function commitAuthSession({ token, tenant, user }) {
  const tenantId = tenant?.tenantid || tenant?.tenantId || tenant?.tenant_id || tenant?.id_tenant || tenant?.id;
  if (!token || !tenantId) throw new Error('AUTH_SESSION_INCOMPLETE');

  setAuthItem('token', token);
  setAuthItem('tenantid', tenantId);
  setAuthItem('tenant', JSON.stringify({ ...(tenant || {}), tenantid: tenantId }));
  setAuthItem('user', JSON.stringify(user || null));
}

export function clearAuthSession() {
  try {
    AUTH_KEYS.forEach((key) => sessionStorage.removeItem(key));
  } catch (_) {}
}

export function readAuthSession() {
  let tenant = null;
  let user = null;
  try { tenant = JSON.parse(getAuthItem('tenant') || 'null'); } catch (_) {}
  try { user = JSON.parse(getAuthItem('user') || 'null'); } catch (_) {}
  return {
    token: getAuthItem('token') || '',
    tenantid: getAuthItem('tenantid') || '',
    tenant,
    user,
  };
}
